// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ResetPassword_componentWrapper__PAeeq","form":"ResetPassword_form__Z43m-","actions":"ResetPassword_actions__nKPiz"};